import classNames from "classnames/bind";
import styles from "./FooterLinksSection.module.scss";

import UIIcon from "common/blocks/UIIcon";
import SmartLink from "common/wrapper/SmartLink";
import type { ResolvedFooterMenu } from "resolvers/base/footerMenuResolver";

const cx = classNames.bind(styles);

export type FooterLinksSectionProps = {
    handleSetActiveFooterMenu(menuName: string): void;
    footerMenuOpen: string | null;
    footerMenu: ResolvedFooterMenu[];
    footerMainTitle: string;
    prefetch?: boolean;
};

const FooterLinksSection: React.FC<FooterLinksSectionProps> = ({
    handleSetActiveFooterMenu,
    footerMenuOpen,
    footerMenu,
    footerMainTitle,
    prefetch = false,
}) => {
    return (
        <div className={cx("links")}>
            <div className={cx("linksWidthContain")}>
                <span className={cx("linksHeader")}>{footerMainTitle}</span>
                <div className={cx("linksContainer")}>
                    {footerMenu?.map((menu) => (
                        <div
                            key={menu.menuHeading}
                            className={cx("listContainer", {
                                listContainerOpen: footerMenuOpen === menu.menuHeading,
                            })}
                        >
                            <span
                                role="button"
                                onClick={() => handleSetActiveFooterMenu(menu.menuHeading)}
                                className={cx("listHeading")}
                                aria-label={menu.menuHeading}
                            >
                                {(menu.menuHeading === "Cars" || menu.menuHeading === "Vans") && (
                                    <span className={cx("browse")}>Browse </span>
                                )}
                                {menu.menuHeading}
                            </span>
                            <span
                                onClick={() => handleSetActiveFooterMenu(menu.menuHeading)}
                                role="button"
                                className={cx("chevronIconContainer")}
                                aria-hidden="true"
                            >
                                <UIIcon className={cx("chevronIcon")} icon="LegacyChevronDown" />
                            </span>
                            <ul className={cx("linksList")} role="menu">
                                {menu.menuItems?.map(({ link, text, target }) => (
                                    <li key={text} className={cx("linksListItem")} role="menuitem">
                                        <SmartLink href={link} prefetch={!!prefetch}>
                                            <a
                                                className={cx("linksListItemLink")}
                                                target={target}
                                                rel={
                                                    target === "_blank"
                                                        ? "noopener noreferrer"
                                                        : undefined
                                                }
                                                aria-label={text}
                                            >
                                                <span
                                                    className={cx("chevronIconContainer")}
                                                    aria-hidden="true"
                                                >
                                                    <UIIcon
                                                        className={cx("chevronIcon")}
                                                        icon="LegacyChevronDown"
                                                    />
                                                </span>
                                                {text}
                                            </a>
                                        </SmartLink>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FooterLinksSection;
